export default "__VITE_ASSET__DsmSRsSX__"